module.exports = __webpack_public_path__ + "img/icon-MA-YouHelp.8b7ce355.png";